var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudents01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    width: 28,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m539.53,818.14c-45.02-.01-90.05.04-135.07-.03-34.62-.05-62.98-24.83-63.33-59.1-.55-55.32-2.26-111.03,3.19-165.91,6.86-69.05,46.39-118.99,107.49-151.43,3.66-1.94,10.36-1.3,14.22.78,49.08,26.47,97.78,26.63,146.91.01,4.56-2.47,12.73-2.78,17.14-.33,68.77,38.23,107.34,95.66,108.51,175.6.66,45.5.19,91.02.11,136.53-.07,38.47-25.5,63.81-64.1,63.88-45.02.08-90.05.02-135.07,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m539.25,188.55c72.8-.02,130.87,57.8,130.87,130.31,0,71.36-60.02,131.23-131.08,130.75-71-.48-130.07-59.58-130.15-130.22-.09-72.64,57.87-130.82,130.36-130.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m370.82,491.91c-21.54,30.16-35.93,62.79-40.52,99.19-1.35,10.74-1.74,21.66-1.79,32.5-.19,46.39-.08,92.78-.08,140.28-48.36,0-95.27,1.19-142.08-.5-23.96-.87-41.09-19.48-41.28-42.88-.34-42.48-1.41-85.28,3.06-127.39,5.11-48.15,33.15-83.63,75.55-106.9,4.3-2.36,12.25-1.27,17.1,1.1,33.23,16.24,66.71,17.64,99.62.92,11.47-5.83,19.94-6.34,30.43,3.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m753,763.95c0-7.92,0-14.68,0-21.45,0-40.05.41-80.1-.11-120.14-.62-48.07-14.09-92.2-43.6-131.13,9.39-8.78,17.47-9.01,28.87-3.19,32.81,16.76,66.6,16.22,99.28-.95,8.19-4.3,13.86-3.94,21.42.61,48.41,29.12,72.88,72.46,75.23,128.08,1.4,33.07.45,66.24.21,99.37-.19,26.95-15.96,47.29-42.11,48.31-45.79,1.78-91.69.5-139.2.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m292.47,486.07c-52.99.44-96.21-41.94-96.99-95.1-.76-51.89,42.63-95.66,95.85-96.68,51.28-.98,94.91,41.8,97.06,91.8,2.35,54.52-43.82,102.15-95.92,99.98Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m786.12,486.07c-51.05,2.06-97.92-44.51-95.48-100.46,2.15-49.24,44.95-91.39,96-91.29,53.49.1,98.14,44.87,96.85,97.08-1.32,53.5-44.3,95.28-97.37,94.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents01);
export default __webpack_public_path__ + "static/media/students-01.d8229a656bde6666aa4ba1631ee19358.svg";
export { ForwardRef as ReactComponent };